// extracted by mini-css-extract-plugin
module.exports = {"rows":"Circles_rows__kBwnR","rows_bottom":"Circles_rows_bottom__1Txbc","rows_right":"Circles_rows_right__3HGBe","row":"Circles_row__3npTP","circle":"Circles_circle__1unAV"};